export default {
  locale: {
    'auto': 'System',
    'en': 'English',
    'zh-hans': 'Chinese',
  },
  home: {
    'intro': 'Welcome to uni-app demo',
    'toggle-langs': 'Change languages',
  },
};
